import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'
import patientRepository from './PatientRepository'
import helpers from '../mixins/helpers'

// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))
class EmergencyRepository extends EventEmitter {
    constructor () {
        super()

        this.collection = db.collection('emergencies')

        return this
    }

    find (id, onSuccess, onError) {
        this.collection.doc(id)
            .get()
            .then((snapshot) => {
                if (snapshot.exists) {
                    onSuccess(snapshot.data())
                } else {
                    onError({message: "This emergency does not exist."})
                }
            })
            .catch(onError)
    }

    allAvailable (type, onSuccess, onError) {
        var office = store.state.offices[store.state.currentOffice]

        this.collection
            .where('type', '==', type)
            .where('hasBeenCancelled', '==', false)
            .where('hasBeenAutoCancelled', '==', false)
            .where('appointmentId', '==', null)
            .where('appointmentInvitationId', '==', null)
            .get()
            .then((querySnapshot) => {
                let emergencies = {}

                querySnapshot.forEach((doc) => {
                    var data = doc.data()

                    // Only emergencies in a 20km radius
                    if (window.distanceBetween(data.location._lat, data.location._long, office.location._lat, office.location._long) <= 20) {
                        emergencies[doc.id] = data
                    }
                });

                onSuccess(emergencies)
            })
            .catch((error) => {
                onError(error)
            })
    }

    allForPatient(patientId, onSuccess, onError) {
        this.collection
            .where('patientId', '==', patientId)
            .where('hasBeenAutoCancelled', '==', false)
            .where('hasBeenCancelled', '==', false)
            .where('appointmentId', '==', null)
            .where('appointmentInvitationId', '==', null)
            .get()
            .then((querySnapshot) => {
                let emergencies = {}

                querySnapshot.forEach((doc) => {
                    if (!doc.data().hasBeenTaken) {
                        emergencies[doc.id] = doc.data()
                    }
                });

                onSuccess(emergencies)
            })
            .catch(onError)
    }

    create(patient, onSuccess, onError) {
        var newEmergency = this.collection.doc()

        let emergency = {
            id: newEmergency.id,
            dateTimeCreated: new Date(),
            appointmentId: null,
            appointmentInvitationId: null,
            hasBeenCancelled: false,
            hasBeenAutoCancelled: false,
            type: patient.type,
            patientId: patient.id,
            patientFirstName: patient.firstName,
            patientLastName: patient.lastName,
            patientAge: parseInt(patient.age),
            patientEmail: patient.email,
            patientPhone: patient.phone,
            locality: patient.locality,
            zipCode: patient.zipCode,
            location: patient.location,
            symptoms: Object.freeze(patient.symptoms),
            pictures: [],
        }

        this.collection.doc(emergency.id)
            .set(emergency)
            .then(() => {
                if (store.state.patient.email === null) {

                    patientRepository
                        .update({
                            id: patient.id,
                            email: helpers.methods.hashPatientInfo(patient.email)
                        }, onSuccess, onError)
                } else {
                    onSuccess()
                }
            })
            .catch(onError)
    }

    delete(emergency, onSuccess, onError) {
        this.collection
            .doc(emergency.id)
            .update({
                hasBeenCancelled: true
            })
            .then(onSuccess)
            .catch(onError)
    }

    // Attach listeners to Firebase
    attachFirebaseListeners () {
        this.collection.onSnapshot((querySnapshot) => {
            for (var key in querySnapshot.docChanges()) {
                var docChange = querySnapshot.docChanges()[key]
                var type = docChange.type
                var doc = docChange.doc

                this.onChanged(type, doc)
            }
        })
    }

    onChanged (type, doc) {
        this.emit(type, doc.id, doc.exists ? doc.data() : null)
    }
}

export default new EmergencyRepository()



// WEBPACK FOOTER //
// ./src/data/EmergencyRepository.js